<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-header">{{ getDialogTitle() }}</h2>

  <!-- Add New Mode -->
  <div mat-dialog-content *ngIf="currentMode === 'add-new'">
    <app-add-pyramid-item
      [largeShareholderId]="data.largeShareholderId"
      [dialogRef]="dialogRef"
      [isCreatingNewPyramidalShareholder]="true"
      (formValidityChanged)="onFormValidityChange($event)">
    </app-add-pyramid-item>
  </div>

  <!-- Search & Connect Mode -->
  <div mat-dialog-content *ngIf="currentMode === 'search-connect'">
    <app-add-pyramid-search-connect
      [largeShareholderId]="data.largeShareholderId"
      [dialogRef]="dialogRef"
      (formValidityChanged)="onFormValidityChange($event)">
    </app-add-pyramid-search-connect>
  </div>

  <!-- Dialog Actions -->
  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" type="button" (click)="onAddNewFromSearch()"
            *ngIf="currentMode === 'search-connect'">
      <mat-icon>add</mat-icon>
      Add New Pyramidal Shareholder
    </button>
    <button mat-flat-button type="button" (click)="onBack()" *ngIf="currentMode === 'add-new'">
      <mat-icon>arrow_back</mat-icon>
      Back to Search
    </button>
    <button mat-flat-button type="button" class="nrg-error-flat-button back-button" (click)="onCancel()">
      <mat-icon>clear</mat-icon>
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="onConfirm()" [disabled]="!isAddNewItemFormValid">
      <mat-icon>add</mat-icon>
      Add Pyramid Item
    </button>
  </div>
</div>
